class Frame {
  constructor({
    id,
    inspectionId,
    imageLocation,
    imageUrl,
    frameId,
    classLabel,
    classCertainty,
    chainage,
    chainageNumber,
    isHidden,
    isAccepted,
    allClassBreakdown,
    atJoint,
    atClock,
    toClock,
    contDefectStart,
    contDefectEnd,
    quantity1Value,
    quantity1Units,
    quantity2Value,
    quantity2Units,
    remarks,
    isMatched,
    parentVideo,
    pipeTypeSewer,
    material,
    defectId,
    defectClass,
    defectCode,
    defectStrScore,
    defectSerScore,
    defectScoreSeverity,
    defectScoreIsShown,
    timeReference,
  } = {}) {
    this.id = id;
    this.inspectionId = inspectionId;
    this.imageLocation = imageLocation;
    this.imageUrl = imageUrl;
    this.frameId = frameId;
    this.classLabel = classLabel;
    this.classCertainty = classCertainty;
    this.chainage = chainage;
    this.chainageNumber = chainageNumber;
    this.isHidden = isHidden;
    this.isAccepted = isAccepted;
    this.allClassBreakdown = allClassBreakdown;
    this.atJoint = atJoint;
    this.atClock = atClock;
    this.toClock = toClock;
    this.contDefectStart = contDefectStart;
    this.contDefectEnd = contDefectEnd;
    this.quantity1Value = quantity1Value;
    this.quantity1Units = quantity1Units;
    this.quantity2Value = quantity2Value;
    this.quantity2Units = quantity2Units;
    this.remarks = remarks;
    this.isMatched = isMatched;
    this.parentVideo = parentVideo;
    this.pipeTypeSewer = pipeTypeSewer;
    this.material = material;
    this.defectId = defectId;
    this.defectClass = defectClass;
    this.defectCode = defectCode;
    this.defectStrScore = defectStrScore;
    this.defectSerScore = defectSerScore;
    this.defectScoreSeverity = defectScoreSeverity;
    this.defectScoreIsShown = defectScoreIsShown;
    this.timeReference = timeReference;
  }

  static fromServerModel(data = {}) {
    return new Frame({
      id: data.id,
      inspectionId: data.inspectionId,
      imageLocation: data.imageLocation,
      imageUrl: data.imageUrl,
      frameId: data.frameId,
      classLabel: data.classLabel,
      classCertainty: data.classCertainty,
      chainage: data.chainage,
      chainageNumber: data.chainageNumber,
      isHidden: data.isHidden,
      isAccepted: data.isAccepted,
      allClassBreakdown: data.allClassBreakdown,
      atJoint: data.atJoint,
      atClock: data.atClock,
      toClock: data.toClock,
      contDefectStart: data.contDefectStart,
      contDefectEnd: data.contDefectEnd,
      quantity1Value: data.quantity1Value,
      quantity1Units: data.quantity1Units,
      quantity2Value: data.quantity2Value,
      quantity2Units: data.quantity2Units,
      remarks: data.remarks,
      isMatched: data.isMatched,
      parentVideo: data.parentVideo,
      pipeTypeSewer: data.pipeTypeSewer,
      material: data.material,
      defectId: data.defectId,
      defectClass: data.defectClass,
      defectCode: data.defectCode,
      defectStrScore: data.defectStrScore,
      defectSerScore: data.defectSerScore,
      defectScoreSeverity: data.defectScoreSeverity,
      defectScoreIsShown: data.defectScoreIsShown,
      timeReference: data.timeReference,
    });
  }

  toServerModel() {
    return {
      id: this.id,
      inspectionId: this.inspectionId,
      imageLocation: this.imageLocation,
      imageUrl: this.imageUrl,
      frameId: this.frameId,
      classLabel: this.classLabel,
      classCertainty: this.classCertainty,
      chainage: this.chainage,
      chainageNumber: this.chainageNumber,
      isHidden: this.isHidden,
      isAccepted: this.isAccepted,
      allClassBreakdown: this.allClassBreakdown,
      atJoint: this.atJoint,
      atClock: this.atClock,
      toClock: this.toClock,
      contDefectStart: this.contDefectStart,
      contDefectEnd: this.contDefectEnd,
      quantity1Value: this.quantity1Value,
      quantity1Units: this.quantity1Units,
      quantity2Value: this.quantity2Value,
      quantity2Units: this.quantity2Units,
      remarks: this.remarks,
      isMatched: this.isMatched,
      parentVideo: this.parentVideo,
      pipeTypeSewer: this.pipeTypeSewer,
      material: this.material,
      defectId: this.defectId,
      defectClass: this.defectClass,
      defectCode: this.defectCode,
      defectStrScore: this.defectStrScore,
      defectSerScore: this.defectSerScore,
      defectScoreSeverity: this.defectScoreSeverity,
      defectScoreIsShown: this.defectScoreIsShown,
      timeReference: this.timeReference,
    };
  }
}

export default Frame;
